import { generateVideoUrl } from 'src/Feature/Videos/app';
import { UrlTokenType } from '../models/url-token-type';
import { replaceUrlTokens } from './replace-url-tokens';
var videoTokenRegex = /\[video\|[0-9a-z\-]+\]/mgi;
export var replaceVideoTokens = function (html, product) {
    videoTokenRegex.lastIndex = 0;
    return product ? replaceUrlTokens(videoTokenRegex, UrlTokenType.Video, product, html, generateVideoUrl) : html;
};
